var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternIslamic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 402 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 62.1552C125.743 58.1747 121.517 56.652 116.819 56.771C120.554 53.1754 122.441 48.7434 121.576 42.4709C116.8 41.7956 112.102 42.3494 107.659 45.4816C107.974 40.033 105.379 36.2916 101.015 33.3135C96.6313 36.2916 94.0368 40.0333 94.3708 45.4816C89.9087 42.3494 85.2304 41.7956 80.4341 42.4709C79.5889 48.7434 81.4562 53.1754 85.2106 56.771C80.4929 56.652 76.2862 58.1747 74.0455 62.1552C76.2865 66.1359 80.4929 67.6587 85.2106 67.5397C81.4562 71.1352 79.5886 75.5677 80.4341 81.8403C85.2304 82.5151 89.9087 81.9618 94.3708 78.8295C94.0368 84.2774 96.6313 88.0191 101.015 90.9972C105.379 88.0191 107.974 84.2774 107.659 78.8295C112.102 81.9618 116.799 82.5151 121.576 81.8403C122.441 75.5677 120.554 71.1352 116.819 67.5397C121.517 67.6589 125.743 66.1359 127.984 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.313 62.1552C116.563 58.301 111.374 56.1508 105.025 57.8998C107.482 52.2447 105.614 47.0805 101.015 43.5997C96.415 47.0805 94.5279 52.2447 97.0046 57.8998C90.6554 56.1508 85.4464 58.301 83.6968 62.1552C85.4464 66.0096 90.6554 68.1598 97.0046 66.4108C94.5279 72.0663 96.415 77.23 101.015 80.7114C105.614 77.2298 107.482 72.0661 105.025 66.4108C111.374 68.1598 116.564 66.0096 118.313 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1813 57.7517C86.567 54.7385 84.7977 51.2925 85.3876 46.9598C89.1618 46.0938 92.8573 47.3269 96.4349 49.665L89.1813 57.7517Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 57.7517C115.443 54.7385 117.212 51.2925 116.622 46.9598C112.848 46.0938 109.173 47.3269 105.575 49.665L112.848 57.7517Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1813 66.5591C86.567 69.5723 84.7977 73.0183 85.3876 77.3511C89.1618 78.2171 92.8573 76.984 96.4349 74.6458L89.1813 66.5591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 66.5591C115.443 69.5723 117.212 73.0183 116.622 77.3511C112.848 78.2171 109.173 76.984 105.575 74.6458L112.848 66.5591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 58.5891C102.981 58.5891 104.573 60.1911 104.573 62.1551C104.573 64.1194 102.981 65.7214 101.015 65.7214C99.0491 65.7214 97.4374 64.1194 97.4374 62.1551C97.4374 60.1911 99.0491 58.5891 101.015 58.5891Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.594 133.311C131.208 133.311 70.8218 133.311 10.4158 133.311L1 123.902V117.85L25.2371 93.629H1V89.3496H24.7457L20.3623 85.1471H5.56056C5.56056 80.4209 5.56056 75.6947 5.56056 70.9685L1 66.613C1 63.6413 1 60.6697 1 57.6976L5.56056 53.342C5.56056 48.6156 5.56056 43.8896 5.56056 39.1632H20.3623L24.7457 34.961H1V30.6816H25.2371L1 6.46077V0.40902L10.4158 -9C70.8218 -9 131.208 -9 191.594 -9L201.01 0.40902V6.46077L176.793 30.6816H201.01V34.961H177.284L181.668 39.1632H196.47C196.47 43.8896 196.47 48.6156 196.47 53.342L201.01 57.6976C201.01 60.6697 201.01 63.6413 201.01 66.613L196.47 70.9685C196.47 75.6947 196.47 80.4209 196.47 85.1471H181.668L177.284 89.3496H201.01V93.629H176.793L201.01 117.85V123.902L191.594 133.311Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.033 129.031L101.015 106.007L77.9769 129.031C93.3289 129.031 108.681 129.031 124.033 129.031Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 99.9544L111.61 89.3498H128.318V73.1045L139.267 62.1552L128.318 51.2063V34.961H111.61L101.015 24.3562L90.4001 34.961H73.7112V51.2063L62.7624 62.1552L73.7112 73.1045V89.3498H90.4001L101.015 99.9544Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 18.3044L124.033 -4.72058C108.681 -4.72058 93.3289 -4.72058 77.9769 -4.72058L101.015 18.3044Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7081 62.1551L32.2548 86.5994C32.2548 70.3032 32.2548 54.0073 32.2548 37.7111L56.7081 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 86.5288L22.0725 80.8679H9.82614V69.1421L2.53326 62.1551L9.82614 55.1685V43.4426H22.0725L27.9892 37.7817C27.9892 54.0311 27.9892 70.2799 27.9892 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 30.6816L44.1864 22.2521H60.1088V6.99303L69.4261 -1.92761V30.6816H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 18.8337L32.2548 27.7558V-4.72058H66.163L57.3567 3.70842H41.5721V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 21.3299L73.7113 -2.94824V30.6816H88.6311L97.9877 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 7.98755H45.8573V17.9727H55.8431V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 27.3799V-4.72058H12.1849L4.02728 3.43529L27.9892 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 34.9609L59.7351 59.1296L69.4261 49.4337V34.9609H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 93.6289L44.1864 102.058H60.1088V117.318L69.4261 126.238V93.6289H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 105.477L32.2548 96.5555V129.031H66.163L57.3567 120.602H41.5721V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 102.981L73.7113 127.259V93.6289H88.6311L97.9877 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 106.338H45.8573V116.323H55.8431V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 96.9305V129.031H12.1849L4.02728 120.876L27.9892 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 89.3498L59.7351 65.1814L69.4261 74.8768V89.3498H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.322 62.1551L169.755 86.5994C169.755 70.3032 169.755 54.0073 169.755 37.7111L145.322 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 86.5288L179.938 80.8679H192.184V69.1421L199.477 62.1551L192.184 55.1685V43.4426H179.938L174.041 37.7817C174.041 54.0311 174.041 70.2799 174.041 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 30.6816L157.824 22.2521H141.902V6.99303L132.584 -1.92761V30.6816H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 18.8337L169.755 27.7558V-4.72058H135.867L144.653 3.70842H160.438V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 21.3299L128.318 -2.94824V30.6816H113.379L104.042 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 7.98755H146.187V17.9727H156.173V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 27.3799V-4.72058H189.825L197.983 3.43529L174.041 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 34.9609L142.295 59.1296L132.584 49.4337V34.9609H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 93.6289L157.824 102.058H141.902V117.318L132.584 126.238V93.6289H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 105.477L169.755 96.5555V129.031H135.867L144.653 120.602H160.438V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 102.981L128.318 127.259V93.6289H113.379L104.042 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 106.338H146.187V116.323H156.173V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 96.9305V129.031H189.825L197.983 120.876L174.041 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 89.3498L142.295 65.1814L132.584 74.8768V89.3498H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 62.1552C125.743 58.1747 121.517 56.652 116.819 56.771C120.554 53.1754 122.441 48.7434 121.576 42.4709C116.8 41.7956 112.102 42.3494 107.659 45.4816C107.974 40.033 105.379 36.2916 101.015 33.3135C96.6313 36.2916 94.0368 40.0333 94.3708 45.4816C89.9087 42.3494 85.2304 41.7956 80.4341 42.4709C79.5889 48.7434 81.4562 53.1754 85.2106 56.771C80.4929 56.652 76.2862 58.1747 74.0455 62.1552C76.2865 66.1359 80.4929 67.6587 85.2106 67.5397C81.4562 71.1352 79.5886 75.5677 80.4341 81.8403C85.2304 82.5151 89.9087 81.9618 94.3708 78.8295C94.0368 84.2774 96.6313 88.0191 101.015 90.9972C105.379 88.0191 107.974 84.2774 107.659 78.8295C112.102 81.9618 116.799 82.5151 121.576 81.8403C122.441 75.5677 120.554 71.1352 116.819 67.5397C121.517 67.6589 125.743 66.1359 127.984 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.313 62.1552C116.563 58.301 111.374 56.1508 105.025 57.8998C107.482 52.2447 105.614 47.0805 101.015 43.5997C96.415 47.0805 94.5279 52.2447 97.0046 57.8998C90.6554 56.1508 85.4464 58.301 83.6968 62.1552C85.4464 66.0096 90.6554 68.1598 97.0046 66.4108C94.5279 72.0663 96.415 77.23 101.015 80.7114C105.614 77.2298 107.482 72.0661 105.025 66.4108C111.374 68.1598 116.564 66.0096 118.313 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1813 57.7517C86.567 54.7385 84.7977 51.2925 85.3876 46.9598C89.1618 46.0938 92.8573 47.3269 96.4349 49.665",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 57.7517C115.443 54.7385 117.212 51.2925 116.622 46.9598C112.848 46.0938 109.173 47.3269 105.575 49.665",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1813 66.5591C86.567 69.5723 84.7977 73.0183 85.3876 77.3511C89.1618 78.2171 92.8573 76.984 96.4349 74.6458",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 66.5591C115.443 69.5723 117.212 73.0183 116.622 77.3511C112.848 78.2171 109.173 76.984 105.575 74.6458",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 58.5891C102.981 58.5891 104.573 60.1911 104.573 62.1551C104.573 64.1194 102.981 65.7214 101.015 65.7214C99.0491 65.7214 97.4374 64.1194 97.4374 62.1551C97.4374 60.1911 99.0491 58.5891 101.015 58.5891Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.594 133.311C131.208 133.311 70.8218 133.311 10.4158 133.311L1 123.902V117.85L25.2371 93.629H1V89.3496H24.7457L20.3623 85.1471H5.56056C5.56056 80.4209 5.56056 75.6947 5.56056 70.9685L1 66.613C1 63.6413 1 60.6697 1 57.6976L5.56056 53.342C5.56056 48.6156 5.56056 43.8896 5.56056 39.1632H20.3623L24.7457 34.961H1V30.6816H25.2371L1 6.46077V0.40902L10.4158 -9C70.8218 -9 131.208 -9 191.594 -9L201.01 0.40902V6.46077L176.793 30.6816H201.01V34.961H177.284L181.668 39.1632H196.47C196.47 43.8896 196.47 48.6156 196.47 53.342L201.01 57.6976C201.01 60.6697 201.01 63.6413 201.01 66.613L196.47 70.9685C196.47 75.6947 196.47 80.4209 196.47 85.1471H181.668L177.284 89.3496H201.01V93.629H176.793L201.01 117.85V123.902L191.594 133.311Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.033 129.031L101.015 106.007L77.9769 129.031C93.3289 129.031 108.681 129.031 124.033 129.031Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 99.9544L111.61 89.3498H128.318V73.1045L139.267 62.1552L128.318 51.2063V34.961H111.61L101.015 24.3562L90.4001 34.961H73.7112V51.2063L62.7624 62.1552L73.7112 73.1045V89.3498H90.4001L101.015 99.9544Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 18.3044L124.033 -4.72058C108.681 -4.72058 93.3289 -4.72058 77.9769 -4.72058L101.015 18.3044Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7081 62.1551L32.2548 86.5994C32.2548 70.3032 32.2548 54.0073 32.2548 37.7111L56.7081 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 86.5288L22.0725 80.8679H9.82614V69.1421L2.53326 62.1551L9.82614 55.1685V43.4426H22.0725L27.9892 37.7817C27.9892 54.0311 27.9892 70.2799 27.9892 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 30.6816L44.1864 22.2521H60.1088V6.99303L69.4261 -1.92761V30.6816H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 18.8337L32.2548 27.7558V-4.72058H66.163L57.3567 3.70842H41.5721V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 21.3299L73.7113 -2.94824V30.6816H88.6311L97.9877 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 7.98755H45.8573V17.9727H55.8431V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 27.3799V-4.72058H12.1849L4.02728 3.43529L27.9892 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 34.9609L59.7351 59.1296L69.4261 49.4337V34.9609H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 93.6289L44.1864 102.058H60.1088V117.318L69.4261 126.238V93.6289H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 105.477L32.2548 96.5555V129.031H66.163L57.3567 120.602H41.5721V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 102.981L73.7113 127.259V93.6289H88.6311L97.9877 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 106.338H45.8573V116.323H55.8431V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 96.9305V129.031H12.1849L4.02728 120.876L27.9892 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 89.3498L59.7351 65.1814L69.4261 74.8768V89.3498H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.322 62.1551L169.755 86.5994C169.755 70.3032 169.755 54.0073 169.755 37.7111L145.322 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 86.5288L179.938 80.8679H192.184V69.1421L199.477 62.1551L192.184 55.1685V43.4426H179.938L174.041 37.7817C174.041 54.0311 174.041 70.2799 174.041 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 30.6816L157.824 22.2521H141.902V6.99303L132.584 -1.92761V30.6816H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 18.8337L169.755 27.7558V-4.72058H135.867L144.653 3.70842H160.438V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 21.3299L128.318 -2.94824V30.6816H113.379L104.042 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 7.98755H146.187V17.9727H156.173V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 27.3799V-4.72058H189.825L197.983 3.43529L174.041 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 34.9609L142.295 59.1296L132.584 49.4337V34.9609H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 93.6289L157.824 102.058H141.902V117.318L132.584 126.238V93.6289H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 105.477L169.755 96.5555V129.031H135.867L144.653 120.602H160.438V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 102.981L128.318 127.259V93.6289H113.379L104.042 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 106.338H146.187V116.323H156.173V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 96.9305V129.031H189.825L197.983 120.876L174.041 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 89.3498L142.295 65.1814L132.584 74.8768V89.3498H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.036 62.1552C276.277 58.1747 280.503 56.652 285.201 56.771C281.466 53.1754 279.579 48.7434 280.444 42.4709C285.22 41.7956 289.919 42.3494 294.361 45.4816C294.047 40.033 296.641 36.2916 301.005 33.3135C305.389 36.2916 307.964 40.0333 307.649 45.4816C312.111 42.3494 316.79 41.7956 321.586 42.4709C322.431 48.7434 320.564 53.1754 316.809 56.771C321.527 56.652 325.734 58.1747 327.975 62.1552C325.734 66.1359 321.527 67.6587 316.809 67.5397C320.564 71.1352 322.431 75.5677 321.586 81.8403C316.79 82.5151 312.111 81.9618 307.649 78.8295C307.964 84.2774 305.389 88.0191 301.005 90.9972C296.641 88.0191 294.047 84.2774 294.361 78.8295C289.919 81.9618 285.221 82.5151 280.444 81.8403C279.579 75.5677 281.466 71.1352 285.201 67.5397C280.503 67.6589 276.277 66.1359 274.036 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.707 62.1552C285.437 58.301 290.646 56.1508 296.995 57.8998C294.518 52.2447 296.405 47.0805 301.005 43.5997C305.605 47.0805 307.492 52.2447 305.015 57.8998C311.364 56.1508 316.573 58.301 318.323 62.1552C316.573 66.0096 311.364 68.1598 305.015 66.4108C307.492 72.0663 305.605 77.23 301.005 80.7114C296.405 77.2298 294.518 72.0661 296.995 66.4108C290.646 68.1598 285.437 66.0096 283.707 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.839 57.7517C315.453 54.7385 317.222 51.2925 316.632 46.9598C312.839 46.0938 309.163 47.3269 305.585 49.665L312.839 57.7517Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.172 57.7517C286.557 54.7385 284.788 51.2925 285.397 46.9598C289.172 46.0938 292.847 47.3269 296.445 49.665L289.172 57.7517Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.839 66.5591C315.453 69.5723 317.222 73.0183 316.632 77.3511C312.839 78.2171 309.163 76.984 305.585 74.6458L312.839 66.5591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.172 66.5591C286.557 69.5723 284.788 73.0183 285.397 77.3511C289.172 78.2171 292.847 76.984 296.445 74.6458L289.172 66.5591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 58.5891C299.039 58.5891 297.447 60.1911 297.447 62.1551C297.447 64.1194 299.039 65.7214 301.005 65.7214C302.971 65.7214 304.583 64.1194 304.583 62.1551C304.583 60.1911 302.971 58.5891 301.005 58.5891Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.426 133.311C270.812 133.311 331.198 133.311 391.604 133.311L401 123.902V117.85L376.782 93.629H401V89.3496H377.274L381.657 85.1471H396.459C396.459 80.4209 396.459 75.6947 396.459 70.9685L401 66.613C401 63.6413 401 60.6697 401 57.6976L396.459 53.342C396.459 48.6156 396.459 43.8896 396.459 39.1632H381.657L377.274 34.961H401V30.6816H376.782L401 6.46077V0.40902L391.604 -9C331.198 -9 270.812 -9 210.426 -9L201.01 0.40902V6.46077L225.227 30.6816H201.01V34.961H224.736L220.352 39.1632H205.55C205.55 43.8896 205.55 48.6156 205.55 53.342L201.01 57.6976C201.01 60.6697 201.01 63.6413 201.01 66.613L205.55 70.9685C205.55 75.6947 205.55 80.4209 205.55 85.1471H220.352L224.736 89.3496H201.01V93.629H225.227L201.01 117.85V123.902L210.426 133.311Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.987 129.031L301.005 106.007L324.023 129.031C308.691 129.031 293.339 129.031 277.987 129.031Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 99.9544L290.41 89.3498H273.702V73.1045L262.753 62.1552L273.702 51.2063V34.961H290.41L301.005 24.3562L311.62 34.961H328.309V51.2063L339.258 62.1552L328.309 73.1045V89.3498H311.62L301.005 99.9544Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 18.3044L277.987 -4.72058C293.339 -4.72058 308.691 -4.72058 324.024 -4.72058L301.005 18.3044Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.312 62.1551L369.765 86.5994C369.765 70.3032 369.765 54.0073 369.765 37.7111L345.312 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 86.5288L379.948 80.8679H392.174V69.1421L399.467 62.1551L392.174 55.1685V43.4426H379.948L374.031 37.7817C374.031 54.0311 374.031 70.2799 374.031 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 30.6816L357.833 22.2521H341.892V6.99303L332.594 -1.92761V30.6816H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 18.8337L369.765 27.7558V-4.72058H335.857L344.663 3.70842H360.448V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 21.3299L328.309 -2.94824V30.6816H313.389L304.032 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 7.98755H346.177V17.9727H356.163V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 27.3799V-4.72058H389.835L397.973 3.43529L374.031 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 34.9609L342.285 59.1296L332.594 49.4337V34.9609H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 93.6289L357.833 102.058H341.892V117.318L332.594 126.238V93.6289H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 105.477L369.765 96.5555V129.031H335.857L344.663 120.602H360.448V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 102.981L328.309 127.259V93.6289H313.389L304.032 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 106.338H346.177V116.323H356.163V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 96.9305V129.031H389.835L397.973 120.876L374.031 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 89.3498L342.285 65.1814L332.594 74.8768V89.3498H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.698 62.1551L232.265 86.5994C232.265 70.3032 232.265 54.0073 232.265 37.7111L256.698 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 86.5288L222.063 80.8679H209.836V69.1421L202.543 62.1551L209.836 55.1685V43.4426H222.063L227.979 37.7817C227.979 54.0311 227.979 70.2799 227.979 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 30.6816L244.196 22.2521H260.119V6.99303L269.416 -1.92761V30.6816H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 18.8337L232.265 27.7558V-4.72058H266.153L257.347 3.70842H241.562V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 21.3299L273.701 -2.94824V30.6816H288.621L297.978 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 7.98755H245.848V17.9727H255.833V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 27.3799V-4.72058H212.195L204.037 3.43529L227.979 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 34.9609L259.725 59.1296L269.416 49.4337V34.9609H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 93.6289L244.196 102.058H260.119V117.318L269.416 126.238V93.6289H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 105.477L232.265 96.5555V129.031H266.153L257.347 120.602H241.562V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 102.981L273.701 127.259V93.6289H288.621L297.978 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 106.338H245.848V116.323H255.833V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 96.9305V129.031H212.195L204.037 120.876L227.979 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 89.3498L259.725 65.1814L269.416 74.8768V89.3498H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.036 62.1552C276.277 58.1747 280.503 56.652 285.201 56.771C281.466 53.1754 279.579 48.7434 280.444 42.4709C285.22 41.7956 289.919 42.3494 294.361 45.4816C294.047 40.033 296.641 36.2916 301.005 33.3135C305.389 36.2916 307.964 40.0333 307.649 45.4816C312.111 42.3494 316.79 41.7956 321.586 42.4709C322.431 48.7434 320.564 53.1754 316.809 56.771C321.527 56.652 325.734 58.1747 327.975 62.1552C325.734 66.1359 321.527 67.6587 316.809 67.5397C320.564 71.1352 322.431 75.5677 321.586 81.8403C316.79 82.5151 312.111 81.9618 307.649 78.8295C307.964 84.2774 305.389 88.0191 301.005 90.9972C296.641 88.0191 294.047 84.2774 294.361 78.8295C289.919 81.9618 285.221 82.5151 280.444 81.8403C279.579 75.5677 281.466 71.1352 285.201 67.5397C280.503 67.6589 276.277 66.1359 274.036 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.707 62.1552C285.437 58.301 290.646 56.1508 296.995 57.8998C294.518 52.2447 296.405 47.0805 301.005 43.5997C305.605 47.0805 307.492 52.2447 305.015 57.8998C311.364 56.1508 316.573 58.301 318.323 62.1552C316.573 66.0096 311.364 68.1598 305.015 66.4108C307.492 72.0663 305.605 77.23 301.005 80.7114C296.405 77.2298 294.518 72.0661 296.995 66.4108C290.646 68.1598 285.437 66.0096 283.707 62.1552Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.839 57.7517C315.453 54.7385 317.222 51.2925 316.632 46.9598C312.839 46.0938 309.163 47.3269 305.585 49.665",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 57.7517C286.557 54.7385 284.788 51.2925 285.397 46.9598C289.172 46.0938 292.847 47.3269 296.445 49.665",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.839 66.5591C315.453 69.5723 317.222 73.0183 316.632 77.3511C312.839 78.2171 309.163 76.984 305.585 74.6458",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 66.5591C286.557 69.5723 284.788 73.0183 285.397 77.3511C289.172 78.2171 292.847 76.984 296.445 74.6458",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 58.5891C299.039 58.5891 297.447 60.1911 297.447 62.1551C297.447 64.1194 299.039 65.7214 301.005 65.7214C302.971 65.7214 304.583 64.1194 304.583 62.1551C304.583 60.1911 302.971 58.5891 301.005 58.5891Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.426 133.311C270.812 133.311 331.198 133.311 391.604 133.311L401 123.902V117.85L376.782 93.629H401V89.3496H377.274L381.657 85.1471H396.459C396.459 80.4209 396.459 75.6947 396.459 70.9685L401 66.613C401 63.6413 401 60.6697 401 57.6976L396.459 53.342C396.459 48.6156 396.459 43.8896 396.459 39.1632H381.657L377.274 34.961H401V30.6816H376.782L401 6.46077V0.40902L391.604 -9C331.198 -9 270.812 -9 210.426 -9L201.01 0.40902V6.46077L225.227 30.6816H201.01V34.961H224.736L220.352 39.1632H205.55C205.55 43.8896 205.55 48.6156 205.55 53.342L201.01 57.6976C201.01 60.6697 201.01 63.6413 201.01 66.613L205.55 70.9685C205.55 75.6947 205.55 80.4209 205.55 85.1471H220.352L224.736 89.3496H201.01V93.629H225.227L201.01 117.85V123.902L210.426 133.311Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.987 129.031L301.005 106.007L324.023 129.031C308.691 129.031 293.339 129.031 277.987 129.031Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 99.9544L290.41 89.3498H273.702V73.1045L262.753 62.1552L273.702 51.2063V34.961H290.41L301.005 24.3562L311.62 34.961H328.309V51.2063L339.258 62.1552L328.309 73.1045V89.3498H311.62L301.005 99.9544Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 18.3044L277.987 -4.72058C293.339 -4.72058 308.691 -4.72058 324.024 -4.72058L301.005 18.3044Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.312 62.1551L369.765 86.5994C369.765 70.3032 369.765 54.0073 369.765 37.7111L345.312 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 86.5288L379.948 80.8679H392.174V69.1421L399.467 62.1551L392.174 55.1685V43.4426H379.948L374.031 37.7817C374.031 54.0311 374.031 70.2799 374.031 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 30.6816L357.833 22.2521H341.892V6.99303L332.594 -1.92761V30.6816H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 18.8337L369.765 27.7558V-4.72058H335.857L344.663 3.70842H360.448V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 21.3299L328.309 -2.94824V30.6816H313.389L304.032 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 7.98755H346.177V17.9727H356.163V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 27.3799V-4.72058H389.835L397.973 3.43529L374.031 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 34.9609L342.285 59.1296L332.594 49.4337V34.9609H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 93.6289L357.833 102.058H341.892V117.318L332.594 126.238V93.6289H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 105.477L369.765 96.5555V129.031H335.857L344.663 120.602H360.448V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 102.981L328.309 127.259V93.6289H313.389L304.032 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 106.338H346.177V116.323H356.163V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 96.9305V129.031H389.835L397.973 120.876L374.031 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 89.3498L342.285 65.1814L332.594 74.8768V89.3498H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.698 62.1551L232.265 86.5994C232.265 70.3032 232.265 54.0073 232.265 37.7111L256.698 62.1551Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 86.5288L222.063 80.8679H209.836V69.1421L202.543 62.1551L209.836 55.1685V43.4426H222.063L227.979 37.7817C227.979 54.0311 227.979 70.2799 227.979 86.5288Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 30.6816L244.196 22.2521H260.119V6.99303L269.416 -1.92761V30.6816H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 18.8337L232.265 27.7558V-4.72058H266.153L257.347 3.70842H241.562V18.8337Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 21.3299L273.701 -2.94824V30.6816H288.621L297.978 21.3299Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 7.98755H245.848V17.9727H255.833V7.98755Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 27.3799V-4.72058H212.195L204.037 3.43529L227.979 27.3799Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 34.9609L259.725 59.1296L269.416 49.4337V34.9609H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 93.6289L244.196 102.058H260.119V117.318L269.416 126.238V93.6289H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 105.477L232.265 96.5555V129.031H266.153L257.347 120.602H241.562V105.477Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 102.981L273.701 127.259V93.6289H288.621L297.978 102.981Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 106.338H245.848V116.323H255.833V106.338Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 96.9305V129.031H212.195L204.037 120.876L227.979 96.9305Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 89.3498L259.725 65.1814L269.416 74.8768V89.3498H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 200.186C125.743 196.206 121.517 194.682 116.819 194.802C120.554 191.207 122.441 186.774 121.576 180.502C116.8 179.826 112.102 180.38 107.659 183.513C107.974 178.064 105.379 174.322 101.015 171.344C96.6313 174.321 94.0368 178.064 94.3708 183.513C89.9087 180.38 85.2304 179.826 80.4341 180.502C79.5889 186.774 81.4562 191.207 85.2106 194.802C80.4929 194.682 76.2862 196.206 74.0455 200.186C76.2865 204.167 80.4929 205.69 85.2106 205.57C81.4562 209.166 79.5886 213.598 80.4341 219.871C85.2304 220.545 89.9087 219.993 94.3708 216.861C94.0368 222.308 96.6313 226.051 101.015 229.029C105.379 226.051 107.974 222.308 107.659 216.861C112.102 219.993 116.799 220.545 121.576 219.871C122.441 213.598 120.554 209.166 116.819 205.57C121.517 205.69 125.743 204.167 127.984 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.313 200.186C116.563 196.332 111.374 194.181 105.025 195.93C107.482 190.275 105.614 185.111 101.015 181.63C96.415 185.111 94.5279 190.275 97.0046 195.93C90.6554 194.181 85.4464 196.331 83.6968 200.186C85.4464 204.041 90.6554 206.191 97.0046 204.442C94.5279 210.097 96.415 215.261 101.015 218.743C105.614 215.261 107.482 210.097 105.025 204.442C111.374 206.192 116.564 204.041 118.313 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1813 195.783C86.567 192.77 84.7977 189.324 85.3876 184.992C89.1618 184.125 92.8573 185.357 96.4349 187.696L89.1813 195.783Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 195.783C115.443 192.77 117.212 189.324 116.622 184.992C112.848 184.125 109.173 185.357 105.575 187.696L112.848 195.783Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1813 204.59C86.567 207.603 84.7977 211.049 85.3876 215.381C89.1618 216.248 92.8573 215.016 96.4349 212.677L89.1813 204.59Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 204.59C115.443 207.603 117.212 211.049 116.622 215.381C112.848 216.248 109.173 215.016 105.575 212.677L112.848 204.59Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 196.621C102.981 196.621 104.573 198.223 104.573 200.186C104.573 202.15 102.981 203.752 101.015 203.752C99.0491 203.752 97.4374 202.15 97.4374 200.186C97.4374 198.223 99.0491 196.621 101.015 196.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.594 271.341C131.208 271.341 70.8218 271.341 10.4158 271.341L1 261.933V255.881L25.2371 231.659H1V227.38H24.7457L20.3623 223.179H5.56056C5.56056 218.452 5.56056 213.726 5.56056 209.001L1 204.645C1 201.672 1 198.7 1 195.728L5.56056 191.372C5.56056 186.647 5.56056 181.921 5.56056 177.194H20.3623L24.7457 172.991H1V168.712H25.2371L1 144.492V138.44L10.4158 129.031C70.8218 129.031 131.208 129.031 191.594 129.031L201.01 138.44V144.492L176.793 168.712H201.01V172.991H177.284L181.668 177.194H196.47C196.47 181.921 196.47 186.647 196.47 191.372L201.01 195.728C201.01 198.7 201.01 201.672 201.01 204.645L196.47 209.001C196.47 213.726 196.47 218.452 196.47 223.179H181.668L177.284 227.38H201.01V231.659H176.793L201.01 255.881V261.933L191.594 271.341Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.033 267.062L101.015 244.037L77.9769 267.062C93.3289 267.062 108.681 267.062 124.033 267.062Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 237.985L111.61 227.38H128.318V211.135L139.267 200.186L128.318 189.237V172.991H111.61L101.015 162.387L90.4001 172.991H73.7112V189.237L62.7624 200.186L73.7112 211.135V227.38H90.4001L101.015 237.985Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 156.335L124.033 133.311C108.681 133.311 93.3289 133.311 77.9769 133.311L101.015 156.335Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7081 200.186L32.2548 224.63C32.2548 208.334 32.2548 192.039 32.2548 175.743L56.7081 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 224.559L22.0725 218.9H9.82614V207.172L2.53326 200.186L9.82614 193.2V181.473H22.0725L27.9892 175.813C27.9892 192.062 27.9892 208.311 27.9892 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 168.713L44.1864 160.283H60.1088V145.024L69.4261 136.103V168.713H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 156.865L32.2548 165.787V133.311H66.163L57.3567 141.739H41.5721V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 159.361L73.7113 135.083V168.713H88.6311L97.9877 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 146.019H45.8573V156.004H55.8431V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 165.411V133.311H12.1849L4.02728 141.466L27.9892 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 172.991L59.7351 197.161L69.4261 187.464V172.991H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 231.659L44.1864 240.09H60.1088V255.35L69.4261 264.27V231.659H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 243.508L32.2548 234.586V267.061H66.163L57.3567 258.632H41.5721V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 241.012L73.7113 265.29V231.659H88.6311L97.9877 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 244.37H45.8573V254.353H55.8431V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 234.961V267.061H12.1849L4.02728 258.908L27.9892 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 227.38L59.7351 203.212L69.4261 212.908V227.38H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.322 200.186L169.755 224.63C169.755 208.334 169.755 192.039 169.755 175.743L145.322 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 224.559L179.938 218.9H192.184V207.172L199.477 200.186L192.184 193.2V181.473H179.938L174.041 175.813C174.041 192.062 174.041 208.311 174.041 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 168.713L157.824 160.283H141.902V145.024L132.584 136.103V168.713H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 156.865L169.755 165.787V133.311H135.867L144.653 141.739H160.438V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 159.361L128.318 135.083V168.713H113.379L104.042 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 146.019H146.187V156.004H156.173V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 165.411V133.311H189.825L197.983 141.466L174.041 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 172.991L142.295 197.161L132.584 187.464V172.991H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 231.659L157.824 240.09H141.902V255.35L132.584 264.27V231.659H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 243.508L169.755 234.586V267.061H135.867L144.653 258.632H160.438V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 241.012L128.318 265.29V231.659H113.379L104.042 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 244.37H146.187V254.353H156.173V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 234.961V267.061H189.825L197.983 258.908L174.041 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 227.38L142.295 203.212L132.584 212.908V227.38H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 200.186C125.743 196.206 121.517 194.682 116.819 194.802C120.554 191.207 122.441 186.774 121.576 180.502C116.8 179.826 112.102 180.38 107.659 183.513C107.974 178.064 105.379 174.322 101.015 171.344C96.6313 174.321 94.0368 178.064 94.3708 183.513C89.9087 180.38 85.2304 179.826 80.4341 180.502C79.5889 186.774 81.4562 191.207 85.2106 194.802C80.4929 194.682 76.2862 196.206 74.0455 200.186C76.2865 204.167 80.4929 205.69 85.2106 205.57C81.4562 209.166 79.5886 213.598 80.4341 219.871C85.2304 220.545 89.9087 219.993 94.3708 216.861C94.0368 222.308 96.6313 226.051 101.015 229.029C105.379 226.051 107.974 222.308 107.659 216.861C112.102 219.993 116.799 220.545 121.576 219.871C122.441 213.598 120.554 209.166 116.819 205.57C121.517 205.69 125.743 204.167 127.984 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.313 200.186C116.563 196.332 111.374 194.181 105.025 195.93C107.482 190.275 105.614 185.111 101.015 181.63C96.415 185.111 94.5279 190.275 97.0046 195.93C90.6554 194.181 85.4464 196.331 83.6968 200.186C85.4464 204.041 90.6554 206.191 97.0046 204.442C94.5279 210.097 96.415 215.261 101.015 218.743C105.614 215.261 107.482 210.097 105.025 204.442C111.374 206.192 116.564 204.041 118.313 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1813 195.783C86.567 192.77 84.7977 189.324 85.3876 184.992C89.1618 184.125 92.8573 185.357 96.4349 187.696",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 195.783C115.443 192.77 117.212 189.324 116.622 184.992C112.848 184.125 109.173 185.357 105.575 187.696",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1813 204.59C86.567 207.603 84.7977 211.049 85.3876 215.381C89.1618 216.248 92.8573 215.016 96.4349 212.677",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 204.59C115.443 207.603 117.212 211.049 116.622 215.381C112.848 216.248 109.173 215.016 105.575 212.677",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 196.621C102.981 196.621 104.573 198.223 104.573 200.186C104.573 202.15 102.981 203.752 101.015 203.752C99.0491 203.752 97.4374 202.15 97.4374 200.186C97.4374 198.223 99.0491 196.621 101.015 196.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.594 271.341C131.208 271.341 70.8218 271.341 10.4158 271.341L1 261.933V255.881L25.2371 231.659H1V227.38H24.7457L20.3623 223.179H5.56056C5.56056 218.452 5.56056 213.726 5.56056 209.001L1 204.645C1 201.672 1 198.7 1 195.728L5.56056 191.372C5.56056 186.647 5.56056 181.921 5.56056 177.194H20.3623L24.7457 172.991H1V168.712H25.2371L1 144.492V138.44L10.4158 129.031C70.8218 129.031 131.208 129.031 191.594 129.031L201.01 138.44V144.492L176.793 168.712H201.01V172.991H177.284L181.668 177.194H196.47C196.47 181.921 196.47 186.647 196.47 191.372L201.01 195.728C201.01 198.7 201.01 201.672 201.01 204.645L196.47 209.001C196.47 213.726 196.47 218.452 196.47 223.179H181.668L177.284 227.38H201.01V231.659H176.793L201.01 255.881V261.933L191.594 271.341Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.033 267.062L101.015 244.037L77.9769 267.062C93.3289 267.062 108.681 267.062 124.033 267.062Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 237.985L111.61 227.38H128.318V211.135L139.267 200.186L128.318 189.237V172.991H111.61L101.015 162.387L90.4001 172.991H73.7112V189.237L62.7624 200.186L73.7112 211.135V227.38H90.4001L101.015 237.985Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 156.335L124.033 133.311C108.681 133.311 93.3289 133.311 77.9769 133.311L101.015 156.335Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7081 200.186L32.2548 224.63C32.2548 208.334 32.2548 192.039 32.2548 175.743L56.7081 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 224.559L22.0725 218.9H9.82614V207.172L2.53326 200.186L9.82614 193.2V181.473H22.0725L27.9892 175.813C27.9892 192.062 27.9892 208.311 27.9892 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 168.713L44.1864 160.283H60.1088V145.024L69.4261 136.103V168.713H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 156.865L32.2548 165.787V133.311H66.163L57.3567 141.739H41.5721V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 159.361L73.7113 135.083V168.713H88.6311L97.9877 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 146.019H45.8573V156.004H55.8431V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 165.411V133.311H12.1849L4.02728 141.466L27.9892 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 172.991L59.7351 197.161L69.4261 187.464V172.991H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 231.659L44.1864 240.09H60.1088V255.35L69.4261 264.27V231.659H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 243.508L32.2548 234.586V267.061H66.163L57.3567 258.632H41.5721V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 241.012L73.7113 265.29V231.659H88.6311L97.9877 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 244.37H45.8573V254.353H55.8431V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 234.961V267.061H12.1849L4.02728 258.908L27.9892 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 227.38L59.7351 203.212L69.4261 212.908V227.38H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.322 200.186L169.755 224.63C169.755 208.334 169.755 192.039 169.755 175.743L145.322 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 224.559L179.938 218.9H192.184V207.172L199.477 200.186L192.184 193.2V181.473H179.938L174.041 175.813C174.041 192.062 174.041 208.311 174.041 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 168.713L157.824 160.283H141.902V145.024L132.584 136.103V168.713H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 156.865L169.755 165.787V133.311H135.867L144.653 141.739H160.438V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 159.361L128.318 135.083V168.713H113.379L104.042 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 146.019H146.187V156.004H156.173V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 165.411V133.311H189.825L197.983 141.466L174.041 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 172.991L142.295 197.161L132.584 187.464V172.991H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 231.659L157.824 240.09H141.902V255.35L132.584 264.27V231.659H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 243.508L169.755 234.586V267.061H135.867L144.653 258.632H160.438V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 241.012L128.318 265.29V231.659H113.379L104.042 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 244.37H146.187V254.353H156.173V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 234.961V267.061H189.825L197.983 258.908L174.041 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 227.38L142.295 203.212L132.584 212.908V227.38H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.036 200.186C276.277 196.206 280.503 194.682 285.201 194.802C281.466 191.207 279.579 186.774 280.444 180.502C285.22 179.826 289.919 180.38 294.361 183.513C294.047 178.064 296.641 174.322 301.005 171.344C305.389 174.321 307.964 178.064 307.649 183.513C312.111 180.38 316.79 179.826 321.586 180.502C322.431 186.774 320.564 191.207 316.809 194.802C321.527 194.682 325.734 196.206 327.975 200.186C325.734 204.167 321.527 205.69 316.809 205.57C320.564 209.166 322.431 213.598 321.586 219.871C316.79 220.545 312.111 219.993 307.649 216.861C307.964 222.308 305.389 226.051 301.005 229.029C296.641 226.051 294.047 222.308 294.361 216.861C289.919 219.993 285.221 220.545 280.444 219.871C279.579 213.598 281.466 209.166 285.201 205.57C280.503 205.69 276.277 204.167 274.036 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.707 200.186C285.437 196.332 290.646 194.181 296.995 195.93C294.518 190.275 296.405 185.111 301.005 181.63C305.605 185.111 307.492 190.275 305.015 195.93C311.364 194.181 316.573 196.331 318.323 200.186C316.573 204.041 311.364 206.191 305.015 204.442C307.492 210.097 305.605 215.261 301.005 218.743C296.405 215.261 294.518 210.097 296.995 204.442C290.646 206.192 285.437 204.041 283.707 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.839 195.783C315.453 192.77 317.222 189.324 316.632 184.992C312.839 184.125 309.163 185.357 305.585 187.696L312.839 195.783Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.172 195.783C286.557 192.77 284.788 189.324 285.397 184.992C289.172 184.125 292.847 185.357 296.445 187.696L289.172 195.783Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.839 204.59C315.453 207.603 317.222 211.049 316.632 215.381C312.839 216.248 309.163 215.016 305.585 212.677L312.839 204.59Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.172 204.59C286.557 207.603 284.788 211.049 285.397 215.381C289.172 216.248 292.847 215.016 296.445 212.677L289.172 204.59Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 196.621C299.039 196.621 297.447 198.223 297.447 200.186C297.447 202.15 299.039 203.752 301.005 203.752C302.971 203.752 304.583 202.15 304.583 200.186C304.583 198.223 302.971 196.621 301.005 196.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.426 271.341C270.812 271.341 331.198 271.341 391.604 271.341L401 261.933V255.881L376.782 231.659H401V227.38H377.274L381.657 223.179H396.459C396.459 218.452 396.459 213.726 396.459 209.001L401 204.645C401 201.672 401 198.7 401 195.728L396.459 191.372C396.459 186.647 396.459 181.921 396.459 177.194H381.657L377.274 172.991H401V168.712H376.782L401 144.492V138.44L391.604 129.031C331.198 129.031 270.812 129.031 210.426 129.031L201.01 138.44V144.492L225.227 168.712H201.01V172.991H224.736L220.352 177.194H205.55C205.55 181.921 205.55 186.647 205.55 191.372L201.01 195.728C201.01 198.7 201.01 201.672 201.01 204.645L205.55 209.001C205.55 213.726 205.55 218.452 205.55 223.179H220.352L224.736 227.38H201.01V231.659H225.227L201.01 255.881V261.933L210.426 271.341Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.987 267.062L301.005 244.037L324.023 267.062C308.691 267.062 293.339 267.062 277.987 267.062Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 237.985L290.41 227.38H273.702V211.135L262.753 200.186L273.702 189.237V172.991H290.41L301.005 162.387L311.62 172.991H328.309V189.237L339.258 200.186L328.309 211.135V227.38H311.62L301.005 237.985Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 156.335L277.987 133.311C293.339 133.311 308.691 133.311 324.024 133.311L301.005 156.335Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.312 200.186L369.765 224.63C369.765 208.334 369.765 192.039 369.765 175.743L345.312 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 224.559L379.948 218.9H392.174V207.172L399.467 200.186L392.174 193.2V181.473H379.948L374.031 175.813C374.031 192.062 374.031 208.311 374.031 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 168.713L357.833 160.283H341.892V145.024L332.594 136.103V168.713H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 156.865L369.765 165.787V133.311H335.857L344.663 141.739H360.448V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 159.361L328.309 135.083V168.713H313.389L304.032 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 146.019H346.177V156.004H356.163V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 165.411V133.311H389.835L397.973 141.466L374.031 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 172.991L342.285 197.161L332.594 187.464V172.991H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 231.659L357.833 240.09H341.892V255.35L332.594 264.27V231.659H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 243.508L369.765 234.586V267.061H335.857L344.663 258.632H360.448V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 241.012L328.309 265.29V231.659H313.389L304.032 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 244.37H346.177V254.353H356.163V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 234.961V267.061H389.835L397.973 258.908L374.031 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 227.38L342.285 203.212L332.594 212.908V227.38H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.698 200.186L232.265 224.63C232.265 208.334 232.265 192.039 232.265 175.743L256.698 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 224.559L222.063 218.9H209.836V207.172L202.543 200.186L209.836 193.2V181.473H222.063L227.979 175.813C227.979 192.062 227.979 208.311 227.979 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 168.713L244.196 160.283H260.119V145.024L269.416 136.103V168.713H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 156.865L232.265 165.787V133.311H266.153L257.347 141.739H241.562V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 159.361L273.701 135.083V168.713H288.621L297.978 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 146.019H245.848V156.004H255.833V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 165.411V133.311H212.195L204.037 141.466L227.979 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 172.991L259.725 197.161L269.416 187.464V172.991H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 231.659L244.196 240.09H260.119V255.35L269.416 264.27V231.659H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 243.508L232.265 234.586V267.061H266.153L257.347 258.632H241.562V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 241.012L273.701 265.29V231.659H288.621L297.978 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 244.37H245.848V254.353H255.833V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 234.961V267.061H212.195L204.037 258.908L227.979 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 227.38L259.725 203.212L269.416 212.908V227.38H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.036 200.186C276.277 196.206 280.503 194.682 285.201 194.802C281.466 191.207 279.579 186.774 280.444 180.502C285.22 179.826 289.919 180.38 294.361 183.513C294.047 178.064 296.641 174.322 301.005 171.344C305.389 174.321 307.964 178.064 307.649 183.513C312.111 180.38 316.79 179.826 321.586 180.502C322.431 186.774 320.564 191.207 316.809 194.802C321.527 194.682 325.734 196.206 327.975 200.186C325.734 204.167 321.527 205.69 316.809 205.57C320.564 209.166 322.431 213.598 321.586 219.871C316.79 220.545 312.111 219.993 307.649 216.861C307.964 222.308 305.389 226.051 301.005 229.029C296.641 226.051 294.047 222.308 294.361 216.861C289.919 219.993 285.221 220.545 280.444 219.871C279.579 213.598 281.466 209.166 285.201 205.57C280.503 205.69 276.277 204.167 274.036 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.707 200.186C285.437 196.332 290.646 194.181 296.995 195.93C294.518 190.275 296.405 185.111 301.005 181.63C305.605 185.111 307.492 190.275 305.015 195.93C311.364 194.181 316.573 196.331 318.323 200.186C316.573 204.041 311.364 206.191 305.015 204.442C307.492 210.097 305.605 215.261 301.005 218.743C296.405 215.261 294.518 210.097 296.995 204.442C290.646 206.192 285.437 204.041 283.707 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.839 195.783C315.453 192.77 317.222 189.324 316.632 184.992C312.839 184.125 309.163 185.357 305.585 187.696",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 195.783C286.557 192.77 284.788 189.324 285.397 184.992C289.172 184.125 292.847 185.357 296.445 187.696",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.839 204.59C315.453 207.603 317.222 211.049 316.632 215.381C312.839 216.248 309.163 215.016 305.585 212.677",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 204.59C286.557 207.603 284.788 211.049 285.397 215.381C289.172 216.248 292.847 215.016 296.445 212.677",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 196.621C299.039 196.621 297.447 198.223 297.447 200.186C297.447 202.15 299.039 203.752 301.005 203.752C302.971 203.752 304.583 202.15 304.583 200.186C304.583 198.223 302.971 196.621 301.005 196.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.426 271.341C270.812 271.341 331.198 271.341 391.604 271.341L401 261.933V255.881L376.782 231.659H401V227.38H377.274L381.657 223.179H396.459C396.459 218.452 396.459 213.726 396.459 209.001L401 204.645C401 201.672 401 198.7 401 195.728L396.459 191.372C396.459 186.647 396.459 181.921 396.459 177.194H381.657L377.274 172.991H401V168.712H376.782L401 144.492V138.44L391.604 129.031C331.198 129.031 270.812 129.031 210.426 129.031L201.01 138.44V144.492L225.227 168.712H201.01V172.991H224.736L220.352 177.194H205.55C205.55 181.921 205.55 186.647 205.55 191.372L201.01 195.728C201.01 198.7 201.01 201.672 201.01 204.645L205.55 209.001C205.55 213.726 205.55 218.452 205.55 223.179H220.352L224.736 227.38H201.01V231.659H225.227L201.01 255.881V261.933L210.426 271.341Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.987 267.062L301.005 244.037L324.023 267.062C308.691 267.062 293.339 267.062 277.987 267.062Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 237.985L290.41 227.38H273.702V211.135L262.753 200.186L273.702 189.237V172.991H290.41L301.005 162.387L311.62 172.991H328.309V189.237L339.258 200.186L328.309 211.135V227.38H311.62L301.005 237.985Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 156.335L277.987 133.311C293.339 133.311 308.691 133.311 324.024 133.311L301.005 156.335Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.312 200.186L369.765 224.63C369.765 208.334 369.765 192.039 369.765 175.743L345.312 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 224.559L379.948 218.9H392.174V207.172L399.467 200.186L392.174 193.2V181.473H379.948L374.031 175.813C374.031 192.062 374.031 208.311 374.031 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 168.713L357.833 160.283H341.892V145.024L332.594 136.103V168.713H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 156.865L369.765 165.787V133.311H335.857L344.663 141.739H360.448V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 159.361L328.309 135.083V168.713H313.389L304.032 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 146.019H346.177V156.004H356.163V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 165.411V133.311H389.835L397.973 141.466L374.031 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 172.991L342.285 197.161L332.594 187.464V172.991H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 231.659L357.833 240.09H341.892V255.35L332.594 264.27V231.659H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 243.508L369.765 234.586V267.061H335.857L344.663 258.632H360.448V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 241.012L328.309 265.29V231.659H313.389L304.032 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 244.37H346.177V254.353H356.163V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 234.961V267.061H389.835L397.973 258.908L374.031 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 227.38L342.285 203.212L332.594 212.908V227.38H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.698 200.186L232.265 224.63C232.265 208.334 232.265 192.039 232.265 175.743L256.698 200.186Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 224.559L222.063 218.9H209.836V207.172L202.543 200.186L209.836 193.2V181.473H222.063L227.979 175.813C227.979 192.062 227.979 208.311 227.979 224.559Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 168.713L244.196 160.283H260.119V145.024L269.416 136.103V168.713H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 156.865L232.265 165.787V133.311H266.153L257.347 141.739H241.562V156.865Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 159.361L273.701 135.083V168.713H288.621L297.978 159.361Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 146.019H245.848V156.004H255.833V146.019Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 165.411V133.311H212.195L204.037 141.466L227.979 165.411Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 172.991L259.725 197.161L269.416 187.464V172.991H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 231.659L244.196 240.09H260.119V255.35L269.416 264.27V231.659H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 243.508L232.265 234.586V267.061H266.153L257.347 258.632H241.562V243.508Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 241.012L273.701 265.29V231.659H288.621L297.978 241.012Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 244.37H245.848V254.353H255.833V244.37Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 234.961V267.061H212.195L204.037 258.908L227.979 234.961Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 227.38L259.725 203.212L269.416 212.908V227.38H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 338.218C125.743 334.237 121.517 332.714 116.819 332.834C120.554 329.237 122.441 324.806 121.576 318.533C116.8 317.857 112.102 318.412 107.659 321.543C107.974 316.096 105.379 312.353 101.015 309.375C96.6313 312.353 94.0368 316.096 94.3708 321.543C89.9087 318.412 85.2304 317.857 80.4341 318.533C79.5889 324.806 81.4562 329.237 85.2106 332.834C80.4929 332.714 76.2862 334.237 74.0455 338.218C76.2865 342.198 80.4929 343.722 85.2106 343.602C81.4562 347.197 79.5886 351.63 80.4341 357.902C85.2304 358.576 89.9087 358.024 94.3708 354.891C94.0368 360.34 96.6313 364.08 101.015 367.06C105.379 364.08 107.974 360.34 107.659 354.891C112.102 358.024 116.799 358.576 121.576 357.902C122.441 351.63 120.554 347.197 116.819 343.602C121.517 343.722 125.743 342.198 127.984 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.313 338.218C116.563 334.363 111.374 332.213 105.025 333.962C107.482 328.307 105.614 323.143 101.015 319.661C96.415 323.143 94.5279 328.307 97.0046 333.962C90.6554 332.213 85.4464 334.363 83.6968 338.218C85.4464 342.073 90.6554 344.221 97.0046 342.474C94.5279 348.129 96.415 353.293 101.015 356.774C105.614 353.293 107.482 348.129 105.025 342.474C111.374 344.221 116.564 342.073 118.313 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1813 333.815C86.567 330.801 84.7977 327.356 85.3876 323.021C89.1618 322.156 92.8573 323.389 96.4349 325.728L89.1813 333.815Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 333.815C115.443 330.801 117.212 327.356 116.622 323.021C112.848 322.156 109.173 323.389 105.575 325.728L112.848 333.815Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1813 342.621C86.567 345.634 84.7977 349.08 85.3876 353.413C89.1618 354.28 92.8573 353.045 96.4349 350.708L89.1813 342.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 342.621C115.443 345.634 117.212 349.08 116.622 353.413C112.848 354.28 109.173 353.045 105.575 350.708L112.848 342.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 334.652C102.981 334.652 104.573 336.254 104.573 338.218C104.573 340.181 102.981 341.783 101.015 341.783C99.0491 341.783 97.4374 340.181 97.4374 338.218C97.4374 336.254 99.0491 334.652 101.015 334.652Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.594 409.372C131.208 409.372 70.8218 409.372 10.4158 409.372L1 399.965V393.912L25.2371 369.691H1V365.411H24.7457L20.3623 361.209H5.56056C5.56056 356.483 5.56056 351.758 5.56056 347.03L1 342.676C1 339.704 1 336.732 1 333.76L5.56056 329.406C5.56056 324.678 5.56056 319.952 5.56056 315.225H20.3623L24.7457 311.022H1V306.743H25.2371L1 282.524V276.471L10.4158 267.062C70.8218 267.062 131.208 267.062 191.594 267.062L201.01 276.471V282.524L176.793 306.743H201.01V311.022H177.284L181.668 315.225H196.47C196.47 319.952 196.47 324.678 196.47 329.406L201.01 333.76C201.01 336.732 201.01 339.704 201.01 342.676L196.47 347.03C196.47 351.758 196.47 356.483 196.47 361.209H181.668L177.284 365.411H201.01V369.691H176.793L201.01 393.912V399.965L191.594 409.372Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.033 405.093L101.015 382.069L77.9769 405.093C93.3289 405.093 108.681 405.093 124.033 405.093Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 376.016L111.61 365.411H128.318V349.167L139.267 338.218L128.318 327.269V311.023H111.61L101.015 300.417L90.4001 311.023H73.7112V327.269L62.7624 338.218L73.7112 349.167V365.411H90.4001L101.015 376.016Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 294.367L124.033 271.341C108.681 271.341 93.3289 271.341 77.9769 271.341L101.015 294.367Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7081 338.218L32.2548 362.662C32.2548 346.366 32.2548 330.07 32.2548 313.775L56.7081 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 362.591L22.0725 356.929H9.82614V345.204L2.53326 338.218L9.82614 331.229V319.504H22.0725L27.9892 313.843C27.9892 330.094 27.9892 346.342 27.9892 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 306.743L44.1864 298.314H60.1088V283.055L69.4261 274.134V306.743H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 294.896L32.2548 303.818V271.341H66.163L57.3567 279.77H41.5721V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 297.392L73.7113 273.114V306.743H88.6311L97.9877 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 284.049H45.8573V294.035H55.8431V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 303.443V271.341H12.1849L4.02728 279.497L27.9892 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 311.022L59.7351 335.193L69.4261 325.496V311.022H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 369.691L44.1864 378.121H60.1088V393.381L69.4261 402.3V369.691H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 381.54L32.2548 372.617V405.093H66.163L57.3567 396.664H41.5721V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 379.043L73.7113 403.322V369.691H88.6311L97.9877 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 382.401H45.8573V392.385H55.8431V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 372.993V405.093H12.1849L4.02728 396.937L27.9892 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 365.411L59.7351 341.243L69.4261 350.94V365.411H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.322 338.218L169.755 362.662C169.755 346.366 169.755 330.07 169.755 313.775L145.322 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 362.591L179.938 356.929H192.184V345.204L199.477 338.218L192.184 331.229V319.504H179.938L174.041 313.843C174.041 330.094 174.041 346.342 174.041 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 306.743L157.824 298.314H141.902V283.055L132.584 274.134V306.743H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 294.896L169.755 303.818V271.341H135.867L144.653 279.77H160.438V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 297.392L128.318 273.114V306.743H113.379L104.042 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 284.049H146.187V294.035H156.173V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 303.443V271.341H189.825L197.983 279.497L174.041 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 311.022L142.295 335.193L132.584 325.496V311.022H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 369.691L157.824 378.121H141.902V393.381L132.584 402.3V369.691H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 381.54L169.755 372.617V405.093H135.867L144.653 396.664H160.438V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 379.043L128.318 403.322V369.691H113.379L104.042 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 382.401H146.187V392.385H156.173V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 372.993V405.093H189.825L197.983 396.937L174.041 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 365.411L142.295 341.243L132.584 350.94V365.411H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.984 338.218C125.743 334.237 121.517 332.714 116.819 332.834C120.554 329.237 122.441 324.806 121.576 318.533C116.8 317.857 112.102 318.412 107.659 321.543C107.974 316.096 105.379 312.353 101.015 309.375C96.6313 312.353 94.0368 316.096 94.3708 321.543C89.9087 318.412 85.2304 317.857 80.4341 318.533C79.5889 324.806 81.4562 329.237 85.2106 332.834C80.4929 332.714 76.2862 334.237 74.0455 338.218C76.2865 342.198 80.4929 343.722 85.2106 343.602C81.4562 347.197 79.5886 351.63 80.4341 357.902C85.2304 358.576 89.9087 358.024 94.3708 354.891C94.0368 360.34 96.6313 364.08 101.015 367.06C105.379 364.08 107.974 360.34 107.659 354.891C112.102 358.024 116.799 358.576 121.576 357.902C122.441 351.63 120.554 347.197 116.819 343.602C121.517 343.722 125.743 342.198 127.984 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.313 338.218C116.563 334.363 111.374 332.213 105.025 333.962C107.482 328.307 105.614 323.143 101.015 319.661C96.415 323.143 94.5279 328.307 97.0046 333.962C90.6554 332.213 85.4464 334.363 83.6968 338.218C85.4464 342.073 90.6554 344.221 97.0046 342.474C94.5279 348.129 96.415 353.293 101.015 356.774C105.614 353.293 107.482 348.129 105.025 342.474C111.374 344.221 116.564 342.073 118.313 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1813 333.815C86.567 330.801 84.7977 327.356 85.3876 323.021C89.1618 322.156 92.8573 323.389 96.4349 325.728",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 333.815C115.443 330.801 117.212 327.356 116.622 323.021C112.848 322.156 109.173 323.389 105.575 325.728",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1813 342.621C86.567 345.634 84.7977 349.08 85.3876 353.413C89.1618 354.28 92.8573 353.045 96.4349 350.708",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 342.621C115.443 345.634 117.212 349.08 116.622 353.413C112.848 354.28 109.173 353.045 105.575 350.708",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 334.652C102.981 334.652 104.573 336.254 104.573 338.218C104.573 340.181 102.981 341.783 101.015 341.783C99.0491 341.783 97.4374 340.181 97.4374 338.218C97.4374 336.254 99.0491 334.652 101.015 334.652Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.594 409.372C131.208 409.372 70.8218 409.372 10.4158 409.372L1 399.965V393.912L25.2371 369.691H1V365.411H24.7457L20.3623 361.209H5.56056C5.56056 356.483 5.56056 351.758 5.56056 347.03L1 342.676C1 339.704 1 336.732 1 333.76L5.56056 329.406C5.56056 324.678 5.56056 319.952 5.56056 315.225H20.3623L24.7457 311.022H1V306.743H25.2371L1 282.524V276.471L10.4158 267.062C70.8218 267.062 131.208 267.062 191.594 267.062L201.01 276.471V282.524L176.793 306.743H201.01V311.022H177.284L181.668 315.225H196.47C196.47 319.952 196.47 324.678 196.47 329.406L201.01 333.76C201.01 336.732 201.01 339.704 201.01 342.676L196.47 347.03C196.47 351.758 196.47 356.483 196.47 361.209H181.668L177.284 365.411H201.01V369.691H176.793L201.01 393.912V399.965L191.594 409.372Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.033 405.093L101.015 382.069L77.9769 405.093C93.3289 405.093 108.681 405.093 124.033 405.093Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 376.016L111.61 365.411H128.318V349.167L139.267 338.218L128.318 327.269V311.023H111.61L101.015 300.417L90.4001 311.023H73.7112V327.269L62.7624 338.218L73.7112 349.167V365.411H90.4001L101.015 376.016Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.015 294.367L124.033 271.341C108.681 271.341 93.3289 271.341 77.9769 271.341L101.015 294.367Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7081 338.218L32.2548 362.662C32.2548 346.366 32.2548 330.07 32.2548 313.775L56.7081 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 362.591L22.0725 356.929H9.82614V345.204L2.53326 338.218L9.82614 331.229V319.504H22.0725L27.9892 313.843C27.9892 330.094 27.9892 346.342 27.9892 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 306.743L44.1864 298.314H60.1088V283.055L69.4261 274.134V306.743H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 294.896L32.2548 303.818V271.341H66.163L57.3567 279.77H41.5721V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 297.392L73.7113 273.114V306.743H88.6311L97.9877 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 284.049H45.8573V294.035H55.8431V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 303.443V271.341H12.1849L4.02728 279.497L27.9892 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 311.022L59.7351 335.193L69.4261 325.496V311.022H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3998 369.691L44.1864 378.121H60.1088V393.381L69.4261 402.3V369.691H35.3998Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5721 381.54L32.2548 372.617V405.093H66.163L57.3567 396.664H41.5721V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9877 379.043L73.7113 403.322V369.691H88.6311L97.9877 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8431 382.401H45.8573V392.385H55.8431V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9892 372.993V405.093H12.1849L4.02728 396.937L27.9892 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5572 365.411L59.7351 341.243L69.4261 350.94V365.411H35.5572Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.322 338.218L169.755 362.662C169.755 346.366 169.755 330.07 169.755 313.775L145.322 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 362.591L179.938 356.929H192.184V345.204L199.477 338.218L192.184 331.229V319.504H179.938L174.041 313.843C174.041 330.094 174.041 346.342 174.041 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 306.743L157.824 298.314H141.902V283.055L132.584 274.134V306.743H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 294.896L169.755 303.818V271.341H135.867L144.653 279.77H160.438V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 297.392L128.318 273.114V306.743H113.379L104.042 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 284.049H146.187V294.035H156.173V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 303.443V271.341H189.825L197.983 279.497L174.041 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 311.022L142.295 335.193L132.584 325.496V311.022H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.63 369.691L157.824 378.121H141.902V393.381L132.584 402.3V369.691H166.63Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.438 381.54L169.755 372.617V405.093H135.867L144.653 396.664H160.438V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.042 379.043L128.318 403.322V369.691H113.379L104.042 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.173 382.401H146.187V392.385H156.173V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.041 372.993V405.093H189.825L197.983 396.937L174.041 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.453 365.411L142.295 341.243L132.584 350.94V365.411H166.453Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.036 338.218C276.277 334.237 280.503 332.714 285.201 332.834C281.466 329.237 279.579 324.806 280.444 318.533C285.22 317.857 289.919 318.412 294.361 321.543C294.047 316.096 296.641 312.353 301.005 309.375C305.389 312.353 307.964 316.096 307.649 321.543C312.111 318.412 316.79 317.857 321.586 318.533C322.431 324.806 320.564 329.237 316.809 332.834C321.527 332.714 325.734 334.237 327.975 338.218C325.734 342.198 321.527 343.722 316.809 343.602C320.564 347.197 322.431 351.63 321.586 357.902C316.79 358.576 312.111 358.024 307.649 354.891C307.964 360.34 305.389 364.08 301.005 367.06C296.641 364.08 294.047 360.34 294.361 354.891C289.919 358.024 285.221 358.576 280.444 357.902C279.579 351.63 281.466 347.197 285.201 343.602C280.503 343.722 276.277 342.198 274.036 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.707 338.218C285.437 334.363 290.646 332.213 296.995 333.962C294.518 328.307 296.405 323.143 301.005 319.661C305.605 323.143 307.492 328.307 305.015 333.962C311.364 332.213 316.573 334.363 318.323 338.218C316.573 342.073 311.364 344.221 305.015 342.474C307.492 348.129 305.605 353.293 301.005 356.774C296.405 353.293 294.518 348.129 296.995 342.474C290.646 344.221 285.437 342.073 283.707 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.839 333.815C315.453 330.801 317.222 327.356 316.632 323.021C312.839 322.156 309.163 323.389 305.585 325.728L312.839 333.815Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.172 333.815C286.557 330.801 284.788 327.356 285.397 323.021C289.172 322.156 292.847 323.389 296.445 325.728L289.172 333.815Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.839 342.621C315.453 345.634 317.222 349.08 316.632 353.413C312.839 354.28 309.163 353.045 305.585 350.708L312.839 342.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.172 342.621C286.557 345.634 284.788 349.08 285.397 353.413C289.172 354.28 292.847 353.045 296.445 350.708L289.172 342.621Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 334.652C299.039 334.652 297.447 336.254 297.447 338.218C297.447 340.181 299.039 341.783 301.005 341.783C302.971 341.783 304.583 340.181 304.583 338.218C304.583 336.254 302.971 334.652 301.005 334.652Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.426 409.372C270.812 409.372 331.198 409.372 391.604 409.372L401 399.965V393.912L376.782 369.691H401V365.411H377.274L381.657 361.209H396.459C396.459 356.483 396.459 351.758 396.459 347.03L401 342.676C401 339.704 401 336.732 401 333.76L396.459 329.406C396.459 324.678 396.459 319.952 396.459 315.225H381.657L377.274 311.022H401V306.743H376.782L401 282.524V276.471L391.604 267.062C331.198 267.062 270.812 267.062 210.426 267.062L201.01 276.471V282.524L225.227 306.743H201.01V311.022H224.736L220.352 315.225H205.55C205.55 319.952 205.55 324.678 205.55 329.406L201.01 333.76C201.01 336.732 201.01 339.704 201.01 342.676L205.55 347.03C205.55 351.758 205.55 356.483 205.55 361.209H220.352L224.736 365.411H201.01V369.691H225.227L201.01 393.912V399.965L210.426 409.372Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.987 405.093L301.005 382.069L324.023 405.093C308.691 405.093 293.339 405.093 277.987 405.093Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 376.016L290.41 365.411H273.702V349.167L262.753 338.218L273.702 327.269V311.023H290.41L301.005 300.417L311.62 311.023H328.309V327.269L339.258 338.218L328.309 349.167V365.411H311.62L301.005 376.016Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 294.367L277.987 271.341C293.339 271.341 308.691 271.341 324.024 271.341L301.005 294.367Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.312 338.218L369.765 362.662C369.765 346.366 369.765 330.07 369.765 313.775L345.312 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 362.591L379.948 356.929H392.174V345.204L399.467 338.218L392.174 331.229V319.504H379.948L374.031 313.843C374.031 330.094 374.031 346.342 374.031 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 306.743L357.833 298.314H341.892V283.055L332.594 274.134V306.743H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 294.896L369.765 303.818V271.341H335.857L344.663 279.77H360.448V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 297.392L328.309 273.114V306.743H313.389L304.032 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 284.049H346.177V294.035H356.163V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 303.443V271.341H389.835L397.973 279.497L374.031 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 311.022L342.285 335.193L332.594 325.496V311.022H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 369.691L357.833 378.121H341.892V393.381L332.594 402.3V369.691H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 381.54L369.765 372.617V405.093H335.857L344.663 396.664H360.448V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 379.043L328.309 403.322V369.691H313.389L304.032 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 382.401H346.177V392.385H356.163V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 372.993V405.093H389.835L397.973 396.937L374.031 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 365.411L342.285 341.243L332.594 350.94V365.411H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.698 338.218L232.265 362.662C232.265 346.366 232.265 330.07 232.265 313.775L256.698 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 362.591L222.063 356.929H209.836V345.204L202.543 338.218L209.836 331.229V319.504H222.063L227.979 313.843C227.979 330.094 227.979 346.342 227.979 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 306.743L244.196 298.314H260.119V283.055L269.416 274.134V306.743H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 294.896L232.265 303.818V271.341H266.153L257.347 279.77H241.562V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 297.392L273.701 273.114V306.743H288.621L297.978 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 284.049H245.848V294.035H255.833V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 303.443V271.341H212.195L204.037 279.497L227.979 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 311.022L259.725 335.193L269.416 325.496V311.022H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 369.691L244.196 378.121H260.119V393.381L269.416 402.3V369.691H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 381.54L232.265 372.617V405.093H266.153L257.347 396.664H241.562V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 379.043L273.701 403.322V369.691H288.621L297.978 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 382.401H245.848V392.385H255.833V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 372.993V405.093H212.195L204.037 396.937L227.979 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 365.411L259.725 341.243L269.416 350.94V365.411H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.036 338.218C276.277 334.237 280.503 332.714 285.201 332.834C281.466 329.237 279.579 324.806 280.444 318.533C285.22 317.857 289.919 318.412 294.361 321.543C294.047 316.096 296.641 312.353 301.005 309.375C305.389 312.353 307.964 316.096 307.649 321.543C312.111 318.412 316.79 317.857 321.586 318.533C322.431 324.806 320.564 329.237 316.809 332.834C321.527 332.714 325.734 334.237 327.975 338.218C325.734 342.198 321.527 343.722 316.809 343.602C320.564 347.197 322.431 351.63 321.586 357.902C316.79 358.576 312.111 358.024 307.649 354.891C307.964 360.34 305.389 364.08 301.005 367.06C296.641 364.08 294.047 360.34 294.361 354.891C289.919 358.024 285.221 358.576 280.444 357.902C279.579 351.63 281.466 347.197 285.201 343.602C280.503 343.722 276.277 342.198 274.036 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.707 338.218C285.437 334.363 290.646 332.213 296.995 333.962C294.518 328.307 296.405 323.143 301.005 319.661C305.605 323.143 307.492 328.307 305.015 333.962C311.364 332.213 316.573 334.363 318.323 338.218C316.573 342.073 311.364 344.221 305.015 342.474C307.492 348.129 305.605 353.293 301.005 356.774C296.405 353.293 294.518 348.129 296.995 342.474C290.646 344.221 285.437 342.073 283.707 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.839 333.815C315.453 330.801 317.222 327.356 316.632 323.021C312.839 322.156 309.163 323.389 305.585 325.728",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 333.815C286.557 330.801 284.788 327.356 285.397 323.021C289.172 322.156 292.847 323.389 296.445 325.728",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.839 342.621C315.453 345.634 317.222 349.08 316.632 353.413C312.839 354.28 309.163 353.045 305.585 350.708",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 342.621C286.557 345.634 284.788 349.08 285.397 353.413C289.172 354.28 292.847 353.045 296.445 350.708",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 334.652C299.039 334.652 297.447 336.254 297.447 338.218C297.447 340.181 299.039 341.783 301.005 341.783C302.971 341.783 304.583 340.181 304.583 338.218C304.583 336.254 302.971 334.652 301.005 334.652Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.426 409.372C270.812 409.372 331.198 409.372 391.604 409.372L401 399.965V393.912L376.782 369.691H401V365.411H377.274L381.657 361.209H396.459C396.459 356.483 396.459 351.758 396.459 347.03L401 342.676C401 339.704 401 336.732 401 333.76L396.459 329.406C396.459 324.678 396.459 319.952 396.459 315.225H381.657L377.274 311.022H401V306.743H376.782L401 282.524V276.471L391.604 267.062C331.198 267.062 270.812 267.062 210.426 267.062L201.01 276.471V282.524L225.227 306.743H201.01V311.022H224.736L220.352 315.225H205.55C205.55 319.952 205.55 324.678 205.55 329.406L201.01 333.76C201.01 336.732 201.01 339.704 201.01 342.676L205.55 347.03C205.55 351.758 205.55 356.483 205.55 361.209H220.352L224.736 365.411H201.01V369.691H225.227L201.01 393.912V399.965L210.426 409.372Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.987 405.093L301.005 382.069L324.023 405.093C308.691 405.093 293.339 405.093 277.987 405.093Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 376.016L290.41 365.411H273.702V349.167L262.753 338.218L273.702 327.269V311.023H290.41L301.005 300.417L311.62 311.023H328.309V327.269L339.258 338.218L328.309 349.167V365.411H311.62L301.005 376.016Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.005 294.367L277.987 271.341C293.339 271.341 308.691 271.341 324.024 271.341L301.005 294.367Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.312 338.218L369.765 362.662C369.765 346.366 369.765 330.07 369.765 313.775L345.312 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 362.591L379.948 356.929H392.174V345.204L399.467 338.218L392.174 331.229V319.504H379.948L374.031 313.843C374.031 330.094 374.031 346.342 374.031 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 306.743L357.833 298.314H341.892V283.055L332.594 274.134V306.743H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 294.896L369.765 303.818V271.341H335.857L344.663 279.77H360.448V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 297.392L328.309 273.114V306.743H313.389L304.032 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 284.049H346.177V294.035H356.163V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 303.443V271.341H389.835L397.973 279.497L374.031 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 311.022L342.285 335.193L332.594 325.496V311.022H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.62 369.691L357.833 378.121H341.892V393.381L332.594 402.3V369.691H366.62Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.448 381.54L369.765 372.617V405.093H335.857L344.663 396.664H360.448V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.032 379.043L328.309 403.322V369.691H313.389L304.032 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.163 382.401H346.177V392.385H356.163V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.031 372.993V405.093H389.835L397.973 396.937L374.031 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.463 365.411L342.285 341.243L332.594 350.94V365.411H366.463Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.698 338.218L232.265 362.662C232.265 346.366 232.265 330.07 232.265 313.775L256.698 338.218Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 362.591L222.063 356.929H209.836V345.204L202.543 338.218L209.836 331.229V319.504H222.063L227.979 313.843C227.979 330.094 227.979 346.342 227.979 362.591Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 306.743L244.196 298.314H260.119V283.055L269.416 274.134V306.743H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 294.896L232.265 303.818V271.341H266.153L257.347 279.77H241.562V294.896Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 297.392L273.701 273.114V306.743H288.621L297.978 297.392Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 284.049H245.848V294.035H255.833V284.049Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 303.443V271.341H212.195L204.037 279.497L227.979 303.443Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 311.022L259.725 335.193L269.416 325.496V311.022H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.39 369.691L244.196 378.121H260.119V393.381L269.416 402.3V369.691H235.39Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.562 381.54L232.265 372.617V405.093H266.153L257.347 396.664H241.562V381.54Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.978 379.043L273.701 403.322V369.691H288.621L297.978 379.043Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 382.401H245.848V392.385H255.833V382.401Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.979 372.993V405.093H212.195L204.037 396.937L227.979 372.993Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.567 365.411L259.725 341.243L269.416 350.94V365.411H235.567Z",
    stroke: "#606C5E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternIslamic);
export default __webpack_public_path__ + "static/media/patternIslamic.d7bfb371da87241dcb44564c9833f774.svg";
export { ForwardRef as ReactComponent };